/**
 * Separates studies the user added from ones our own code creates.
 *
 * TradingView reports both through the same `study_event` 'create'. Code paths
 * that create studies on their own (default Volume, profile/compare studies
 * re-synced from persisted state) wrap their `createStudy` promise here; while
 * any such creation is pending — plus a short grace for a late event — created
 * studies are not counted as "Added Indicator". Module-level on purpose: the
 * call sites live in different closures and effects, and a user can't realistically
 * add an indicator in the sub-second window this suppresses.
 */
const GRACE_MS = 300

let pendingProgrammaticCreates = 0

export function markProgrammaticStudyCreate<T>(creation: Promise<T>): Promise<T> {
  pendingProgrammaticCreates++
  const release = () => {
    setTimeout(() => {
      pendingProgrammaticCreates = Math.max(0, pendingProgrammaticCreates - 1)
    }, GRACE_MS)
  }
  creation.then(release, release)
  return creation
}

export function isProgrammaticStudyCreatePending(): boolean {
  return pendingProgrammaticCreates > 0
}

/** Test seam. */
export function resetStudyCreateGateForTest(): void {
  pendingProgrammaticCreates = 0
}
